module.exports = __webpack_public_path__ + "static/media/30.06dbcb0d.jpg";